<template>
  <div id="cachorro">
  <Slider v-bind:tipo="$t('slider_cachorro')"/>
<!-- ___________________ Croqueta ___________________ -->
  <div id="croqueta_nufit_cachorro">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="content">
        <h2 class="title1 paddingT80">{{ $t('titulo1') }}</h2>
        <div class="uk-text-center" uk-parallax="stroke: 100%; viewport: 0.4">
          <!-- <img src="/public/img/recursos/svg_croqueta_cachorro.svg" alt="" uk-svg> -->
          <img v-bind:src="$t('svg_cachorro')" alt="" uk-svg class="escritorio">
          <img v-bind:src="$t('croqueta_cachorro')" uk-svg alt="" class="movil" uk-scrollspy="cls: uk-animation-fade; repeat: false">  
        </div>
      </div>
    </div>
  </div>
<!-- ___________________ Beneficios Cachorro ___________________ -->
  <div id="beneficio_nufit_cachorro" class="uk-background-cover">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales" uk-parallax="bgy: 300,-20; viewport: 1.5;" style="min-height:500px;">
        <img src="/public/img/nparallax/img_hojas_1.png" uk-parallax=" y: -50,300; viewport: 1.6" style=""/> 
      </div>
      <div class="content">
        <h2 class="title2 colorMorado paddingT80" v-html="$t('beneficio_titulo_cachorro')"></h2>
        <p class="text1 colorCafe"><span class="max600">{{ $t('beneficio_texto_cachorro') }}</span></p>
        <div class="uk-grid" uk-scrollspy="cls: uk-animation-fade; target: .elementB; delay: 100; repeat: false">
          <CardBeneficios v-for="n in 6" :key="n.id" 
          v-bind:info="[$t('beneficio_iconos_cachorro['+(n-1)+']')]"/>
        </div>
      </div>
      <div class="laterales" uk-parallax="bgy: 300,-20; viewport: 1.5;" style="min-height:500px;background-repeat:no-repeat;">
        <img src="/public/img/nparallax/img_chicharos_3.png" uk-parallax=" y: 350,450; viewport: 1" style=""/> 
        <img src="/public/img/nparallax/img_chicharos_2.png" uk-parallax=" y: 150,0; viewport: 1" style=""/>
        <img src="/public/img/nparallax/img_chicharos_1.png" uk-parallax=" y: -700,-650; viewport: 1" style=""/> 
      </div>
    </div>
  </div>
  <div class="separador" uk-parallax="bgy: -300; bgx: -50; scale: .6,1;"><img src="/public/img/recursos/_img_mobil_separador_2.png"/> </div>
  <!-- ___________________ Presentacion ___________________ -->
  <div id="presentacion_nufit_cachorro" class="uk-background-cover" uk-parallax="bgy: -700">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales" uk-parallax="bgy: 100,-10000; bgx:50; scale: 0.8,1;" style="min-height:600px;">
        <img src="/public/img/nparallax/img_amaranto_1.png" uk-parallax="y: 200,-200; viewport: 1"/> 
      </div>
      <div class="content">
        <h2 class="title2 colorMorado paddingT80" v-html="$t('presentacion_titulo_cachorro')"></h2>
        <br>
        <img src="/public/img/recursos/img_nufit_pres_cachorro.png" class="imgSacos" uk-scrollspy="cls: uk-animation-fade; target: .elementB; delay: 100; repeat: false">
        <br>
        <ul class="listImg" uk-scrollspy="cls: uk-animation-fade; target: .elementB; delay: 100; repeat: false">
          <li class="elementB"><img src="/public/img/recursos/img_25kg_cachorro.png" alt=""> </li>
          <li class="elementB"><img src="/public/img/recursos/img_8kg_cachorro.png" alt=""> </li>
          <li class="elementB"><img src="/public/img/recursos/img_4kg_cachorro.png" alt=""> </li>
          <li class="elementB"><img src="/public/img/recursos/img_2kg_cachorro.png" alt=""> </li>
        </ul>
        <br><br><p class="text1 colorCafe" v-html="$t('alimentacion_titulo_cachorro')" style="margin:0px;"></p>

      </div>
      <div class="laterales s1">
      </div>
    </div>
    
  </div>
  <!-- ___________________ Indicaciones Cachorro ___________________ -->
  <div id="indicaciones_nufit_cachorro" class="paddingT80">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales" uk-parallax="">
        <img src="/public/img/parallax/trigo.png" uk-parallax="opacity: 1; y: 0,-200; viewport: 0.5,0.9" style=""/> 
      </div>
      <div class="content" uk-scrollspy="cls: uk-animation-fade; target: .elementB; delay: 50; repeat: false">
        <div class="uk-grid">
          <div class="uk-width-1-1 uk-width-1-2@m elementB">
            <h2 class="title4 colorMorado " v-html="$t('indicaciones_titulo_cachorro')+':'"></h2> <br>
            <p class="text1 colorCafe">{{ $t('indicaciones_texto_cachorro') }}</p>
            <h2 class="title4 colorMorado" v-html="$t('dosis_titulo_cachorro')+':'"></h2> <br>
            <p class="text1 colorCafe" v-html="$t('dosis_texto_cachorro')"></p>
            <h2 class="title4 colorMorado">{{ $t('via_titulo_cachorro') }}:</h2> <br>
            <p class="text1 colorCafe">{{ $t('via_texto_cachorro') }}</p>
            <h2 class="title4 colorMorado">{{ $t('recomendaciones_titulo_cachorro') }}:</h2> <br>
            <p class="text1 colorCafe" v-html="$t('recomendaciones_texto_cachorro')"></p>
            <h2 class="title4 colorMorado" v-html="$t('advertencias_titulo_cachorro')+':'"></h2> <br>
            <p class="text1 colorCafe" v-html="$t('advertencias_texto_cachorro')"></p>
          </div>
          <div class="uk-width-1-1 uk-width-1-2@m elementB">
            <h2 class="title4 colorMorado">{{ $t('ingredientes_titulo_cachorro') }}:</h2> <br>
            <p class="text1 colorCafe" v-html="$t('ingredientes_texto_cachorro')"></p>
          </div>
        </div>
        
      </div>
      <div class="laterales s2">
        <img src="/public/img/parallax/img_camote_3.png" uk-parallax="opacity: 1; y: 450,50; viewport: 0.9;" style="max-width:200px;"/> 
        <img src="/public/img/parallax/img_camote_2.png" uk-parallax="opacity: 1; y: 0,-450; viewport: 0.9;" style="max-width:200px;"/> 
        <img src="/public/img/parallax/img_camote_1.png" uk-parallax="opacity: 1; y: 0,-1300; viewport: 0.9;" style="max-width:200px;"/> 
      </div>
    </div>
  </div>

  <div class="separador" uk-parallax="bgy: -300; bgx: -50; scale: .6,1;"><img src="/public/img/recursos/_img_mobil_separador_2.png"/> </div>
  <!-- ___________________ Análisis Cachorro  ___________________ -->
  <div id="analisis_garantizado_nufit_cachorro">
    <h2 class="title2 colorMorado paddingT80">{{$t('analisis_titulo_cachorro')}}</h2>
    <div class="uk-grid">
      <div class="uk-width-1-1 uk-width-1-2@m">
        <table class="tableV uk-table uk-table-small table1Analisis borderColorMorado" >
          <tbody>
              <tr class="elementB">
                <td>{{$t('analisis_table_cachorro[0].titulo')}}</td>
                <td>{{$t('analisis_table_adulto[6].titulo')}} 27.0%</td>
              </tr>
              <tr class="elementB">
                <td>{{$t('analisis_table_cachorro[1].titulo')}}</td>
                <td>{{$t('analisis_table_adulto[6].titulo')}} 12.0%</td> 
              </tr>
              <tr class="elementB">
                <td>{{$t('analisis_table_cachorro[2].titulo')}}</td>
                <td>{{$t('analisis_table_adulto[7].titulo')}} 3.5%</td>
              </tr>
          </tbody>
        </table>
      </div>
      <div class="uk-width-1-1 uk-width-1-2@m">
        <table class="tableV uk-table uk-table-small table2Analisis borderColorMorado" >
          <tbody>
              <tr class="elementB"><td>{{$t('analisis_table_cachorro[3].titulo')}}</td><td>{{$t('analisis_table_adulto[7].titulo')}} 12.0%</td></tr>
              <tr class="elementB"><td>{{$t('analisis_table_cachorro[4].titulo')}}</td><td>{{$t('analisis_table_adulto[7].titulo')}} 8.0%</td></tr>
              <tr class="elementB"><td>{{$t('analisis_table_cachorro[5].titulo')}}</td><td>37.5%</td></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- ___________________ Guia Cachorro ___________________ -->
  <div id="guia_de_alimentacion_nufit_cachorro">
    <div style="width:100%;" class="uk-flex-inline uk-flex-center">
      <div class="laterales s3">
        <img src="/public/img/nparallax/img_nopal_3.png" uk-parallax=" y: 800,550; viewport: 0.9"/> 
        <img src="/public/img/nparallax/img_nopal_2.png" uk-parallax=" y: 200,100; scale: .7,.8; viewport: 0.9"/> 
        <img src="/public/img/nparallax/img_nopal_1.png" uk-parallax=" y: -400,-250; scale: .7,.8; viewport: 0.9"/> 
      </div>
      <div class="content">
        <h2 class="title2 colorMorado paddingT80" v-html="$t('guia_titulo_cachorro')"></h2>
        <p class="text1 colorCafe" v-html="$t('guia_texto_cachorro')"></p>
        <div class="uk-flex uk-child-width-1-1@s uk-child-width-1-1@m">
          <div>
            <table class="tableEscritotrio tableVi uk-table uk-table-small borderColorMorado" style="margin: 0 auto;max-width: 900px;" >
              <tbody>
                  <tr class="elementB">
                    <td colspan="2">{{ $t('guia_table2_cachorro[0].titulo') }} </td>
                    <td colspan="2">{{ $t('guia_table2_cachorro[1].titulo') }} </td>
                    <td >{{ $t('guia_table2_cachorro[0].titulo') }} </td>
                    <td colspan="2">{{ $t('guia_table2_cachorro[2].titulo') }} </td>
                  </tr>

                  <tr class="elementB">
                    <td>lbs</td>
                    <td>Kg</td>
                    <td>{{ $t('guia_table2_cachorro[3].titulo') }}</td>
                    <td>{{ $t('guia_table2_cachorro[4].titulo') }}</td>
                    <td>Kg</td>
                    <td>{{ $t('guia_table2_cachorro[3].titulo') }}</td>
                    <td>{{ $t('guia_table2_cachorro[4].titulo') }}</td>
                  </tr>
                  <tr>
                    <td>2 - 6</td>
                    <td>1 - 3</td>
                    <td>100 - 220</td>
                    <td>1 {{$t('guia_table1_cachorro_a')}} 2 <sup>1</sup>&frasl;<sub>4</sub></td>
                    <td>1 - 3</td>
                    <td>70 - 140</td>
                    <td><sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 1 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>6 - 11</td>
                    <td>3 - 5</td>
                    <td>220 -300</td>
                    <td>2 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 3</td>
                    <td>3 - 5</td>
                    <td>140 - 190</td>
                    <td>1 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 1 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>11 - 22</td>
                    <td>5 - 10</td>
                    <td>300 - 480</td>
                    <td>3 {{$t('guia_table1_cachorro_a')}} 4 <sup>3</sup>&frasl;<sub>4</sub></td>
                    <td>5 - 10</td>
                    <td>190 - 310</td>
                    <td>2 {{$t('guia_table1_cachorro_a')}} 3</td>
                  </tr>
                  <tr>
                    <td>22 - 33</td>
                    <td>10 - 15</td>
                    <td>480 - 630</td>
                    <td>4 <sup>3</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 6 <sup>2</sup>&frasl;<sub>3</sub></td>
                    <td>10 - 15</td>
                    <td>310 - 400</td>
                    <td>3 {{$t('guia_table1_cachorro_a')}} 4</td>
                  </tr>
                  <tr>
                    <td>33 - 44</td>
                    <td>15 - 20</td>
                    <td>630 - 770</td>
                    <td>6 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>2</sup>&frasl;<sub>3</sub></td>
                    <td>15 - 20</td>
                    <td>400 - 490</td>
                    <td>4 {{$t('guia_table1_cachorro_a')}} 5</td>
                  </tr>
                  <tr>
                    <td>44 - 55</td>
                    <td>20 - 25</td>
                    <td>770 - 890</td>
                    <td>7 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 9</td>
                    <td>20 - 25</td>
                    <td>490 - 570</td>
                    <td>5 {{$t('guia_table1_cachorro_a')}} 5 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>55 - 66</td>
                    <td>25 - 30</td>
                    <td>890 - 1010</td>
                    <td>9 {{$t('guia_table1_cachorro_a')}} 10</td>
                    <td>25 - 30</td>
                    <td>570 - 640</td>
                    <td> 5 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 6 <sup>1</sup>&frasl;<sub>2</sub></td>
                  </tr>
                  <tr>
                    <td>66 - 77</td>
                    <td>30 - 35</td>
                    <td>1010 - 1120</td>
                    <td>10 {{$t('guia_table1_cachorro_a')}} 11 <sup>1</sup>&frasl;<sub>4</sub></td>
                    <td>30 - 35</td>
                    <td>640 - 710</td>
                    <td>6 <sup>1</sup>&frasl;<sub>2</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>1</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td>77 - 88</td>
                    <td>35 - 40</td>
                    <td>1120 - 1220</td>
                    <td>11 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 12 <sup>1</sup>&frasl;<sub>4</sub></td>
                    <td>35 - 40</td>
                    <td>710 - 780</td>
                    <td>7 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>3</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td class="borderBN">88 - 99</td>
                    <td class="borderBN">40 - 45</td>
                    <td class="borderBN">1220 - 1320</td>
                    <td class="borderBN">12 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 13 <sup>1</sup>&frasl;<sub>4</sub></td>
                    <td class="borderBN">40 - 45</td>
                    <td class="borderBN">780 - 840</td>
                    <td class="borderBN">7 <sup>3</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 8 <sup>1</sup>&frasl;<sub>2</sub></td>
                  </tr>
              </tbody>
            </table>
            
            <table class="movilTable tableVi uk-table uk-table-small borderColorMorado" style="margin: 0 auto;max-width: 900px;" >
              <tbody>
                  <tr class="elementB">
                    <td colspan="2">{{ $t('guia_table2_cachorro[0].titulo') }} </td>
                    <td colspan="2">{{ $t('guia_table2_cachorro[1].titulo') }} </td>
                  </tr>

                  <tr class="elementB">
                    <td>lbs</td>
                    <td>Kg</td>
                    <td>{{ $t('guia_table2_cachorro[3].titulo') }}</td>
                    <td>{{ $t('guia_table2_cachorro[4].titulo') }}</td>
                  </tr>
                  <tr>
                    <td>2 - 6</td>
                    <td>1 - 3</td>
                    <td>100 - 220</td>
                    <td>1 {{$t('guia_table1_cachorro_a')}} 2 <sup>1</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td>6 - 11</td>
                    <td>3 - 5</td>
                    <td>220 -300</td>
                    <td>2 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 3</td>
                  </tr>
                  <tr>
                    <td>11 - 22</td>
                    <td>5 - 10</td>
                    <td>300 - 480</td>
                    <td>3 {{$t('guia_table1_cachorro_a')}} 4 <sup>3</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td>22 - 33</td>
                    <td>10 - 15</td>
                    <td>480 - 630</td>
                    <td>4 <sup>3</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 6 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>33 - 44</td>
                    <td>15 - 20</td>
                    <td>630 - 770</td>
                    <td>6 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>44 - 55</td>
                    <td>20 - 25</td>
                    <td>770 - 890</td>
                    <td>7 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 9</td>
                  </tr>
                  <tr>
                    <td>55 - 66</td>
                    <td>25 - 30</td>
                    <td>890 - 1010</td>
                    <td>9 {{$t('guia_table1_cachorro_a')}} 10</td>
                  </tr>
                  <tr>
                    <td>66 - 77</td>
                    <td>30 - 35</td>
                    <td>1010 - 1120</td>
                    <td>10 {{$t('guia_table1_cachorro_a')}} 11 <sup>1</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td>77 - 88</td>
                    <td>35 - 40</td>
                    <td>1120 - 1220</td>
                    <td>11 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 12 <sup>1</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td class="borderBN">88 - 99</td>
                    <td class="borderBN">40 - 45</td>
                    <td class="borderBN">1220 - 1320</td>
                    <td class="borderBN">12 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 13 <sup>1</sup>&frasl;<sub>4</sub></td>
                  </tr>
              </tbody>
            </table>
            <table class="movilTable tableVi uk-table uk-table-small borderColorMorado" style="margin: 0 auto;max-width: 900px;" >
              <tbody>
                  <tr class="elementB">
                    <td >{{ $t('guia_table2_cachorro[0].titulo') }} </td>
                    <td colspan="2">{{ $t('guia_table2_cachorro[2].titulo') }} </td>
                  </tr>

                  <tr class="elementB">
                    <td>Kg</td>
                    <td>{{ $t('guia_table2_cachorro[3].titulo') }}</td>
                    <td>{{ $t('guia_table2_cachorro[4].titulo') }}</td>
                  </tr>
                  <tr>
                    <td>1 - 3</td>
                    <td>70 - 140</td>
                    <td><sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 1 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>3 - 5</td>
                    <td>140 - 190</td>
                    <td>1 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 1 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>5 - 10</td>
                    <td>190 - 310</td>
                    <td>2 {{$t('guia_table1_cachorro_a')}} 3</td>
                  </tr>
                  <tr>
                    <td>10 - 15</td>
                    <td>310 - 400</td>
                    <td>3 {{$t('guia_table1_cachorro_a')}} 4</td>
                  </tr>
                  <tr>
                    <td>15 - 20</td>
                    <td>400 - 490</td>
                    <td>4 {{$t('guia_table1_cachorro_a')}} 5</td>
                  </tr>
                  <tr>
                    <td>20 - 25</td>
                    <td>490 - 570</td>
                    <td>5 {{$t('guia_table1_cachorro_a')}} 5 <sup>2</sup>&frasl;<sub>3</sub></td>
                  </tr>
                  <tr>
                    <td>25 - 30</td>
                    <td>570 - 640</td>
                    <td> 5 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 6 <sup>1</sup>&frasl;<sub>2</sub></td>
                  </tr>
                  <tr>
                    <td>30 - 35</td>
                    <td>640 - 710</td>
                    <td>6 <sup>1</sup>&frasl;<sub>2</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>1</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td>35 - 40</td>
                    <td>710 - 780</td>
                    <td>7 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>3</sup>&frasl;<sub>4</sub></td>
                  </tr>
                  <tr>
                    <td class="borderBN">40 - 45</td>
                    <td class="borderBN">780 - 840</td>
                    <td class="borderBN">7 <sup>3</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 8 <sup>1</sup>&frasl;<sub>2</sub></td>
                  </tr>
              </tbody>
            </table>
            <br/><br/>

            <table class="tableVi uk-table uk-table-small borderColorMorado" style="margin: 0 auto;" >
              <tr>
                <td class="borderTN">{{ $t('guia_table2_cachorro[0].titulo') }}</td>
                <td class="borderTN" colspan="2">{{ $t('guia_table2_cachorro[5].titulo') }}</td>
              </tr>
              <tr>
                <td>kg</td>
                <td>{{ $t('guia_table2_cachorro[3].titulo') }}</td>
                <td>{{ $t('guia_table2_cachorro[4].titulo') }}</td>
              </tr>
              <tr>
                <td>1- 3</td>
                <td>50 - 110</td>
                <td><sup>1</sup>&frasl;<sub>2</sub> {{$t('guia_table1_cachorro_a')}} 1</td>
              </tr>
              <tr>
                <td>3-5</td>
                <td>110 - 170</td>
                <td>1 {{$t('guia_table1_cachorro_a')}} 1 <sup>2</sup>&frasl;<sub>3</sub></td>
              </tr>
              <tr>
                <td>5 - 10</td>
                <td>170 - 290</td>
                <td>1 <sup>2</sup>&frasl;<sub>3</sub> {{$t('guia_table1_cachorro_a')}} 2 <sup>3</sup>&frasl;<sub>4</sub></td>
              </tr>
              <tr>
                <td>10 - 15</td>
                <td>290 - 400</td>
                <td>2 <sup>3</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 4</td>
              </tr>
              <tr>
                <td>15 - 20</td>
                <td>400 - 510</td>
                <td>4 {{$t('guia_table1_cachorro_a')}} 5 <sup>1</sup>&frasl;<sub>4</sub></td>
              </tr>
              <tr>
                <td>20 - 25</td>
                <td>510 - 620</td>
                <td>5 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 6 <sup>1</sup>&frasl;<sub>4</sub></td>
              </tr>
              <tr>
                <td>25 - 30</td>
                <td>620 - 720</td>
                <td>6 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>1</sup>&frasl;<sub>4</sub></td>
              </tr>
              <tr>
                <td>25 - 30</td>
                <td>620 - 720</td>
                <td>6 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 7 <sup>1</sup>&frasl;<sub>4</sub></td>
              </tr>
              <tr>
                <td>30 - 35</td>
                <td>720 - 810</td>
                <td>7 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 8 <sup>1</sup>&frasl;<sub>4</sub></td>
              </tr>
              <tr>
                <td>35 - 40</td>
                <td>810 - 910</td>
                <td>8 <sup>1</sup>&frasl;<sub>4</sub> {{$t('guia_table1_cachorro_a')}} 9</td>
              </tr>
              <tr>
                <td class="borderBN">40 - 45</td>
                <td class="borderBN">910 - 1000</td>
                <td class="borderBN">9 {{$t('guia_table1_cachorro_a')}} 10</td>
              </tr>
            </table>
            <br>
          </div>
          
        </div>
      </div>
      <div class="laterales" style="background-size:100%;background-repeat:no-repeat;">
        <img src="/public/img/parallax/trigo.png" uk-parallax="opacity: .8,1.2; y: 200,50,-100; viewport: 0.8"/> 
      </div>
    </div>
    
  </div>
    






</div>
</template>

<style>
.colorMorado{
    color: #8A3087;
}
</style>
<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Slider from '../components/Slider.vue'
import CardBeneficios from '../components/CardBeneficios.vue'
export default {
  name: 'Home',
  mounted(){

  },
  components: {
    Slider,
    CardBeneficios
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cachorro.vue